package com.schoolconnect.app.feature.quickannouncements

import com.schoolconnect.app.feature.common.PaginationPolicy

data class QuickAnnouncementRow(
    val id: String,
    val backendId: String,
    val message: String,
    val displayFrom: String,
    val displayUntil: String,
    val status: String,
    val createdBy: String,
    val createdById: String? = null,
    val createdAt: String = "—",
    val updatedBy: String = "—",
    val updatedAt: String = "—"
)

data class QuickAnnouncementDraft(
    val message: String,
    val displayUntil: String,
    val displayTime: String,
    val publish: Boolean
)

data class QuickAnnouncementsUiState(
    val isLoading: Boolean = true,
    val isSaving: Boolean = false,
    val errorMessage: String = "",
    val saveErrorMessage: String = "",
    val searchQuery: String = "",
    val status: String = "",
    val createdBy: String = "",
    val createdById: String? = null,
    val period: String = "All",
    val pageIndex: Int = 0,
    val pageSize: Int = PaginationPolicy.DEFAULT_PAGE_SIZE,
    val rows: List<QuickAnnouncementRow> = emptyList(),
    val totalCount: Int = 0,
    val totalAnnouncements: Int = 0,
    val activeCount: Int = 0,
    val expiredCount: Int = 0,
    val draftCount: Int = 0,
    val saveGeneration: Int = 0,
    val isMutating: Boolean = false,
    val actionErrorMessage: String = "",
    val sortBy: String = "created_at",
    val sortAscending: Boolean = false
) {
}

sealed interface QuickAnnouncementsUiEvent {
    data class SearchChanged(val value: String) : QuickAnnouncementsUiEvent
    data class StatusChanged(val value: String) : QuickAnnouncementsUiEvent
    data class CreatedByChanged(val value: String, val id: String? = null) : QuickAnnouncementsUiEvent
    data class PeriodChanged(val value: String) : QuickAnnouncementsUiEvent
    data object FiltersReset : QuickAnnouncementsUiEvent
    data class PageChanged(val value: Int) : QuickAnnouncementsUiEvent
    data class PageSizeChanged(val value: Int) : QuickAnnouncementsUiEvent
    data class SortChanged(val field: String) : QuickAnnouncementsUiEvent
    data class CreateRequested(val draft: QuickAnnouncementDraft) : QuickAnnouncementsUiEvent
    data class UpdateRequested(val id: String, val currentStatus: String, val draft: QuickAnnouncementDraft) : QuickAnnouncementsUiEvent
    data class DuplicateRequested(val id: String) : QuickAnnouncementsUiEvent
    data class EndNowRequested(val id: String) : QuickAnnouncementsUiEvent
    data class DeleteRequested(val id: String) : QuickAnnouncementsUiEvent
}
